import YearbookRosterIdentityModal, {
  YEARBOOK_ROSTER_IDENTITY_MODAL,
} from './modal';

export { YEARBOOK_ROSTER_IDENTITY_MODAL };

export default YearbookRosterIdentityModal;
